var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.fetched || _vm.company.isFetching)?_c('AppPreloader'):[(_vm.error)?_c('div',[_vm._v(" "+_vm._s(_vm.error)+" ")]):_c('div')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }